import { useEffect } from 'react';
import dining1 from './../assets/images/Dining/dining1.jpeg'
import dining2 from './../assets/images/Dining/dining2.jpeg'
import dining3 from './../assets/images/Dining/dining3.mov'

const Dining = () => {
  useEffect(() => {
    const widgetContainer = document.getElementById('openTableWidgetContainer');

      if (!document.getElementById('openTableWidgetScript')) {
        const script = document.createElement('script');
        script.id = 'openTableWidgetScript';
        script.type = 'text/javascript';
        script.src =
          '//www.opentable.co.uk/widget/reservation/loader?rid=161223&type=standard&theme=standard&color=5&dark=false&iframe=false&domain=couk&lang=en-GB&newtab=false&ot_source=Restaurant%20website&cfe=true';
        script.async = true;
  
        widgetContainer.appendChild(script);
      }
    
  }, []);

  return (
<div className='max-w-[1400px] lg:h-[525px] m-auto py-16 pt-16 px-8 grid lg:grid-cols-3 gap-8 bg-gradient-to-r from-blue-100 to-blue-200 rounded-2xl shadow-lg'>
    <div className='relative lg:col-span-1 col-span-2 flex flex-col justify-center lg:h-[400px]'>
        <h3 className='text-3xl md:text-4xl font-bold'>Our Restaurant</h3>
        <p className='text-lg py-6 leading-relaxed'>The Fox is proud to have a talented brigade of chefs, providing high-quality food at reasonable prices.</p>
        <div id="openTableWidgetContainer" className='mt-6 flex justify-center'></div>
    </div>
    
    <div className='grid grid-cols-2 grid-rows-2 col-span-2 gap-2 lg:h-[400px]'>
        <img className='row-span-1 object-cover w-full h-full p-1 rounded-lg shadow-md' src={dining1} alt="dining 1" />
        <video src={dining3} autoPlay loop muted playsInline className="row-span-2 object-cover w-full h-full p-1 rounded-lg shadow-md"/>
        <img className='row-span-1 object-cover w-full h-full p-1 rounded-lg shadow-md' src={dining2} alt="dining 2" />
    </div>
</div>
    
  )
}

export default Dining